<h2>My Competition Entries</h2>
<div *ngFor = "let contestEntry of contestEntries" class="col-xs-12 margin-between-objects ">
	<contest-entry [contestEntry]="contestEntry" >	
	</contest-entry>	
</div>
<div *ngIf = "!contestEntries"> You have not created any competition entries yet! </div>